import React, { Component } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import SuccessIcon from '@material-ui/icons/CheckCircle';


import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import './snackBarStyle.css'

class DoughnutComponent extends Component {


    getIcon = () => {
        switch (this.props.type) {
            case 'error': return (<ErrorIcon />);
            case 'warning': return (<WarningIcon />);
            case 'info': return (<InfoIcon />);
            case 'success': return (<SuccessIcon />);
            default: return (<InfoIcon />);

        }

    }

    render() {
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={this.props.open}
                autoHideDuration={10000} //Tiempo en milisegundos
                onClose={this.props.onClose}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
            >
                <SnackbarContent
                    aria-describedby="client-snackbar"
                    message={
                        <span id="client-snackbar"  >
                            {
                                this.getIcon()
                            }

                            <p id="message-id">{this.props.message}</p>
                        </span>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.props.onClose}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                    // style={{backgroundColor:'red'}}
                    className={this.props.type}
                />


            </Snackbar>
        )
    }
}

export default DoughnutComponent; 